export const VALOR_DESCONTO_SIMPLIFICADO = 607.2;
export const DEDUCAO_DEPENDENTE = 189.59;

export const LIMITE_ISENCAO_2026 = 5000;
export const LIMITE_TETO_REDUTOR_2026 = 7350;
export const VALOR_FIXO_REDUTOR_2026 = 978.62;
export const VALOR_FIXO_REDUTOR_ISENTO_2026 = 312.89;
export const FATOR_REDUTOR_2026 = 0.133145;
